module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "suppliersidebar"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/supplierproductproposal"
    }
  }, [_vm._v("Propose a Product")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/supplierproducts"
    }
  }, [_vm._v("My Products")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/supplierproduct"
    }
  }, [_vm._v("A Product")])], 1), _vm._v(" "), _c('li', [_vm._v("Product Orders")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffffc5a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SupplierSidebar.vue
// module id = 170
// module chunks = 0